import { Injectable } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";

@Injectable({
  providedIn: "root",
})
export class PrintService {
  isPrinting = false;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
  ) {}

  public printDocument(documentName: string, documentData: string[] = []) {
    this.isPrinting = true;
    void this.router.navigate([
      "/",
      {
        outlets: {
          print: ["print", documentName, documentData.join()],
        },
      },
    ]);
  }

  public onDataReady() {
    setTimeout(() => {
      window.print();
      this.isPrinting = false;
      void this.router.navigate([{ outlets: { print: null } }]);
    });
  }
}
